import { useTranslation } from 'react-i18next'
import Chip from '@mui/material/Chip'
import { expiryStatus, type ExpiryStatus } from '@jupi/shared'
import { useServerClock } from '../hooks/useServerClock'

// "Valid / expires soon / expired" for any dated document: a member's
// licence or medical, an aircraft's ARC or insurance.

const STATUS_COLOR: Record<ExpiryStatus, 'default' | 'success' | 'warning' | 'error'> = {
  none: 'default',
  valid: 'success',
  expiring: 'warning',
  expired: 'error',
}

// Today as YYYY-MM-DD in the club's timezone, by the server-corrected
// clock -- not the browser's own day, which is wrong for a phone still on
// holiday time.
export function useClubToday(): string {
  const { utcMs, timezone } = useServerClock()
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', { timeZone: timezone }).format(utcMs)
}

export function ExpiryChip({ expiryDate }: { expiryDate: string | null | undefined }) {
  const { t } = useTranslation()
  const status = expiryStatus(expiryDate, useClubToday())
  if (status === 'none') return null
  return <Chip size="small" color={STATUS_COLOR[status]} label={t(`licence.status_${status}`)} />
}
